module.exports = {
	"config": {
		"siteTitle": "cncjs",
		"baseColor": "#222",
		"linkPrefix": "",
		"docPages": [
			"/docs/",
			"/docs/installation/",
			"/docs/rpi-setup-guide/",
			"/docs/desktop-app/",
			"/docs/user-guide/",
			"/docs/troubleshooting/",
			"/docs/faq/",
			"/docs/resources/",
			"/docs/about/"
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx"
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/about",
				"stem": "index",
				"path": "docs/about/index.md"
			},
			"requirePath": "docs/about/index.md",
			"path": "/docs/about/",
			"data": {
				"title": "About",
				"contributors": [
					"cheton"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/desktop-app",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/desktop-app",
				"stem": "index",
				"path": "docs/desktop-app/index.md"
			},
			"requirePath": "docs/desktop-app/index.md",
			"path": "/docs/desktop-app/",
			"data": {
				"title": "Desktop App",
				"contributors": [
					"cheton"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/faq",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/faq",
				"stem": "index",
				"path": "docs/faq/index.md"
			},
			"requirePath": "docs/faq/index.md",
			"path": "/docs/faq/",
			"data": {
				"title": "FAQ",
				"contributors": [
					"cheton"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs",
				"stem": "index",
				"path": "docs/index.md"
			},
			"requirePath": "docs/index.md",
			"path": "/docs/",
			"data": {
				"title": "Introduction"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/installation",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/installation",
				"stem": "index",
				"path": "docs/installation/index.md"
			},
			"requirePath": "docs/installation/index.md",
			"path": "/docs/installation/",
			"data": {
				"title": "Installation",
				"contributors": [
					"cheton",
					"AustinSaintAubin"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/resources",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/resources",
				"stem": "index",
				"path": "docs/resources/index.md"
			},
			"requirePath": "docs/resources/index.md",
			"path": "/docs/resources/",
			"data": {
				"title": "Resources",
				"contributors": [
					"cheton"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/rpi-setup-guide",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/rpi-setup-guide",
				"stem": "index",
				"path": "docs/rpi-setup-guide/index.md"
			},
			"requirePath": "docs/rpi-setup-guide/index.md",
			"path": "/docs/rpi-setup-guide/",
			"data": {
				"title": "Raspberry Pi Setup Guide",
				"contributors": [
					"AustinSaintAubin"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/troubleshooting",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/troubleshooting",
				"stem": "index",
				"path": "docs/troubleshooting/index.md"
			},
			"requirePath": "docs/troubleshooting/index.md",
			"path": "/docs/troubleshooting/",
			"data": {
				"title": "Troubleshooting",
				"contributors": [
					"andrewismoody",
					"cheton"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/user-guide",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/user-guide",
				"stem": "index",
				"path": "docs/user-guide/index.md"
			},
			"requirePath": "docs/user-guide/index.md",
			"path": "/docs/user-guide/",
			"data": {
				"title": "User Guide",
				"contributors": [
					"cheton"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md"
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {
				"title": "cncjs",
				"contributors": [
					"cheton"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "nav.jsx",
				"ext": "jsx",
				"name": "nav",
				"extname": ".jsx",
				"basename": "nav.jsx",
				"dirname": "",
				"stem": "nav",
				"path": "nav.jsx"
			},
			"requirePath": "nav.jsx",
			"path": "/nav/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projects",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "projects",
				"stem": "index",
				"path": "projects/index.md"
			},
			"requirePath": "projects/index.md",
			"path": "/projects/",
			"data": {
				"title": "Projects"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0